module.exports = __webpack_public_path__ + "img/JIM-background.434db33b.jpg";